export enum HotelStatus {
    CREATED,
    ACTIVE,
    INACTIVE
}
